import { lazy, useEffect, useState } from "react";
import {
  Routes,
  Route,
  useLocation,
  useNavigate,
  Navigate,
} from "react-router-dom";
import "./App.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "aos/dist/aos.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fontsource/jost";
import "@fontsource/ribeye-marrow";
import "@fontsource/lobster";
import "./assets/style/style.scss";
import "lite-youtube-embed";
import "animate.css";
import "react-toastify/dist/ReactToastify.css";
import AOS from "aos";
import { ToastContainer } from "react-toastify";
import { RouteData } from "./routes/routes";
const TopHeader = lazy(() => import('./components/headercomponents/TopHeder'));
const BottamHeader = lazy(() => import('./components/headercomponents/BottamHeader'));
const Footer = lazy(() => import('./components/footercomponents/Footer'));
const ScrollToTop = lazy(() => import('./components/scrolltopcomponents/ScrollTop'));
const TawkTo = lazy(() => import('./components/chatcomponents/Message'));
const CallAndWhatsapp = lazy(() => import('./components/callcomponents/Call'));
const MobileFooter = lazy(() => import('./components/footercomponents/MobileFooter'));

function App() {
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 3000 });
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (location.pathname === "/") {
      localStorage.removeItem("city_name");
      localStorage.removeItem("country_name");
    }

    const hasVisited = localStorage.getItem("hasVisited");
    if (!hasVisited) {
      if (location.pathname !== "/") {
        setShowModal(true);
      } else {
        setTimeout(() => {
          setShowModal(true);
          localStorage.setItem("hasVisited", "true");
        }, 6000);
      }
    } else if (location.pathname === "/") {
      setShowModal(true);
    }
  }, [location, navigate]);

  useEffect(() => {
    const pathRegex = /^\/\d{4}\/\d{2}\/\d{2}\/(.+)/; 
    const match = location.pathname.match(pathRegex);

    if (match && match[1]) {
      const newPath = `/${match[1]}`; 
      navigate(newPath, { replace: true }); 
    }
  }, [location.pathname, navigate]);

  return (
    <>
      <div>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <ScrollToTop />
        <CallAndWhatsapp />
        <TopHeader />
        <BottamHeader />
        <TawkTo />
        <MobileFooter />
        <Routes location={location} key={location.pathname}>
          {RouteData?.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
      </div>
    </>
  );
}

export default App;
